"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useNewTab = function useNewTab(link) {
  var navOutside = function navOutside() {
    var a = document.createElement('a');
    a.href = link;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  _react.default.useEffect(function () {
    navOutside();
  }, []);
};

var NewTab = function NewTab(_ref) {
  var to = _ref.to;
  useNewTab(to);
  return null;
};

var _default = NewTab;
exports.default = _default;